export enum PspUniqueName {
  iPay = 'ipay',
  Platon = 'platon',
}
